module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/chat-f9d25867072784375cb9a2dc892e576d.svg";